import React from "react";

import styled from "@mui/material/styles/styled";

import Button from "@rui/Button";
import IconButton from "@rui/IconButton";
import Stack, { Row } from "@rui/Stack";
import TextField from "@rui/TextField";

export const TranscriptContainer = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    minWidth: "90%",
    margin: "auto !important",
    marginTop: theme.spacing(1),
    width: "100%",
  },
}));

export const EditSpeakerTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-input": {
    ...theme.typography.bodySecondaryReg,
    height: "16px",
    padding: "8px",
  },
  flexGrow: 1,
}));

export const EditSpeakerButton = styled(Button)({
  height: "32px",
  padding: "8px 12px",
  minWidth: "56px",
  borderRadius: "8px",
});

export const EditSpeakerIconButton = styled(IconButton)(({ theme }) => ({
  width: "32px",
  height: "32px",
  color: theme.palette.shades.neutral[400],
  "& svg": {
    width: "16px",
    height: "16px",
  },
}));

// hack to keep indices consistent when items are hidden;
// virtuoso needs a non-zero height
export const VirtuosoShim = () => <Row height="1px" width="100%" />;
